import AuthLayout from '@layouts/auth/AuthLayout'
import { FormEditorLayout } from '@layouts/FormEditorLayout'
import GeneralLayout from '@layouts/GeneralLayout'
import CampaignPage from '@pages/admin/CampaignPage'
import CampaignsPage from '@pages/admin/CampaignsPage'
import EmployeesPage from '@pages/admin/EmployeesPage'
import FormsCreatePage from '@pages/admin/FormsCreatePage'
import FormsEditPage from '@pages/admin/FormsEditPage'
import FormsPage from '@pages/admin/FormsPage'
import HomePage from '@pages/admin/HomePage'
import Login from '@pages/auth/Login'
import LoginRedirect from '@pages/auth/LoginRedirect'
import DataPrivacy from '@pages/legal/DataPrivacy'
import LegalNotice from '@pages/legal/LegalNotice'
import { FC, useLayoutEffect } from 'react'
import { Navigate, RouteObject, useRoutes } from 'react-router-dom'
import App from '../App'
import settingsRoutes from './settings/SettingsRoutes'

const appRoutes: RouteObject[] = [
  {
    element: <App />,
    children: [
      // Authentication routes
      {
        element: <AuthLayout />,
        children: [
          // MSAL Login redirect route
          { path: '/login-redirect', element: <LoginRedirect /> },
          // Login pages
          { path: '/login', element: <Login /> },
          { path: '*', index: true, element: <Navigate to="/login" /> },
        ],
      },
      {
        element: <GeneralLayout />,
        children: [
          { path: '/', element: <Navigate to="/home" /> },
          { path: '/home', element: <HomePage /> },
          { path: '/employees', element: <EmployeesPage /> },
          { path: '/campaigns', element: <CampaignsPage /> },
          { path: '/campaigns/:campaignId', element: <CampaignPage /> },
          { path: '/forms', element: <FormsPage /> },
          { path: '/settings', children: settingsRoutes },
          { path: '/legal-notice', element: <LegalNotice /> },
          { path: '/data-privacy', element: <DataPrivacy /> },
        ],
      },
      {
        element: <FormEditorLayout />,
        children: [
          { path: '/forms/create', element: <FormsCreatePage /> },
          { path: '/forms/:formId', element: <FormsEditPage /> },
        ],
      },
      // Fallback route
      { path: '*', element: <Navigate to="/" /> },
    ],
  },
]

const AppRoutes: FC = () => {
  const routing = useRoutes(appRoutes)

  useLayoutEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0)
  }, [location.pathname])

  return <>{routing}</>
}

export default AppRoutes
